import RolePanel from "./rolePanel.container";

export default RolePanel;
